import { Coordinates } from '../../../types/GlobalTypes';

export const getCoordinatesStringFromLatLng = (coordinates?: Coordinates) => {
  if (!coordinates) {
    return '';
  }

  return `${coordinates.lat}, ${coordinates.lng}`;
};
